export const getData = (state) => {
    return state.data
}

export const getLoading = (state) => {
    return state.loading
}

export const getError = (state) => {
    return state.error
}

// Categories getters
export const getCategories = (state) => {
    return state.categories
}

export const getCategoriesLoading = (state) => {
    return state.categoriesLoading
}

export const getSelectedCategory = (state) => {
    return state.selectedCategory
}

// Recorded talks getters
export const getRecordedTalks = (state) => {
    return state.recordedTalks
}

export const getRecordedTalksByCategory = (state) => (categoryId) => {
    return state.recordedTalksByCategory[categoryId] || []
}

export const getFavoriteRecordedTalks = (state) => {
    return state.favoriteRecordedTalks
}

export const getSelectedRecordedTalk = (state) => {
    return state.selectedRecordedTalk
}

export const getTalksLoading = (state) => {
    return state.talksLoading
}

export const getCategoryById = (state) => (categoryId) => {
    return state.categories.find(category => category.id === categoryId)
}

export const getRecordedTalkById = (state) => (talkId) => {
    return state.recordedTalks.find(talk => talk.id === talkId) ||
           Object.values(state.recordedTalksByCategory)
               .flat()
               .find(talk => talk.id === talkId)
}

// Last upcoming talk getters
export const getLastUpcomingTalk = (state) => {
    return state.lastUpcomingTalk
}

export const getLastUpcomingTalkLoading = (state) => {
    return state.lastUpcomingTalkLoading
} 